<template>
  <div class="tablediv box">
    <div class="box_f1 box box_v">
      <dv-decoration-7>　超市排行　</dv-decoration-7>
      <div class="box_f1">
        <dv-border-box-6>
          <dv-scroll-board :config="supermarketConfig" />
        </dv-border-box-6>
      </div>

    </div>

    <div class="box_f1 box box_v">
      <dv-decoration-7>　商场排行　</dv-decoration-7>
      <div class="box_f1">
        <dv-border-box-6>
          <dv-scroll-board :config="hypermarketConfig" />
        </dv-border-box-6>

      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'csscTable',
    computed: {
      xiaofeiquanVue() {
        return this.$store.state.xiaofeiquanVue
      },
    },
    created() {
      alert()
      this.supermarketConfig = this.getConfig([['', '', '']])
      this.hypermarketConfig = this.getConfig([['', '', '']])

      if(this.type=='msljt') {
        this.load(33046)
      }
      if(this.type=='ygjt') {
        this.load(87879)
      }
    },
    methods: {
      load(groupId) {
        //GET api/coupon-count/top
        //超市、商场排行统计TOP，按照消费总金额倒叙排列
        //discountCouponTypeNO 01--超市，02--商场
        //groupId 87879--阳光，33046--美食林,空代表不按照集团统计
        this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/top', {
          discountCouponTypeNO: '01',
          groupId: groupId
        },request=> {
          let data = request.rows.map(item=> {
            return this.getMapData(item)
          })
          this.supermarketConfig = this.getConfig(data)
        })
        this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/top', {
          discountCouponTypeNO: '02',
          groupId: groupId
        },request=> {
          let data = request.rows.map(item=> {
            return this.getMapData(item)
          })
          this.hypermarketConfig = this.getConfig(data)
        })
      },
      getMapData(item) {
        return ['<span title="'+item.companyName+'">'+item.companyName+'</span>',
          '<span title="'+item.goodsAmount+'">'+this.toThousands(item.goodsAmount, true)+'</span>',
          '<span title="'+item.consumeNum+'">'+this.toThousands(item.consumeNum, true)+'</span>']
      },
      getConfig(data) {
        if(data.length<1) {
          data = [['', '', '']]
        }
        return {
          header: ['名字', '消费额', '核销(张)'],
          data: data,
          headerBGC: 'rgba(29, 193, 245,.5)',
          oddRowBGC: '',
          evenRowBGC: '',
          index: true,
          waitTime: 3000,
          columnWidth: [35, 110],
          align: ['center','left','center','center']
        }
      },
      paixu(rows) {
        function sortId(a, b) {
          return parseFloat(b.consumeAmount) - parseFloat(a.consumeAmount);
        }
        return rows.sort(sortId)
      },
      toThousands(num, bol) {
        num = parseInt(num)
        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      }
    },
    data () {
      return {
        supermarketConfig: {},
        hypermarketConfig: {}
      }
    },
    props: {
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less">
  .tablediv {
    position: relative;
    width: 100%;
    height: 50%;

    .dv-scroll-board {
      height: 100%;
    }
    .dv-border-box-6 {
      .border-box-content {
        padding: 10px!important;
      }
    }
    .dv-decoration-7 {
      width: 100%;
      height: 25px;
      margin: 20px 0px!important;
      font-size: 16px;
    }
  }
</style>
